<template>
  <div class="relative">    
  </div>
</template>

<script>
export default {
  props: {
  },
  components: {
  },
  computed: {   
  },
  methods: {  
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/components/horizontalNavMenu.scss"
</style>
<style lang="css" scoped>
.router-content{}
</style>
